import FullScreenLayout from '@/layouts/FullScreen';
import SummaryPage from '../views/V2/Home/SummaryPage';
import LoginV2 from '../views/Home/Loginv2';
import Loginv2Old from '../views/Home/Loginv2Old';

import BasicLayoutV2 from '@/layouts/BasicV2';
import {wrapModelLoaderAsBeforeRouterEnterHook} from '../lib/model';
import {diagnoseConfig} from '../layouts/config/leftSidebar';

const importEnv = require('./_import_' + process.env.NODE_ENV);

export default [
    {
        path: '/loginV2',
        component: FullScreenLayout,
        meta: {
            title: '登录'
        },
        children: [
            {
                path: '',
                name: 'loginV2',
                meta: {
                    title: '登录',
                    allowNotLogin: true
                },
                component: Loginv2Old
            }
        ]
    },
    // 线上先不展示新版登录页
    {
        path: '/loginV2New',
        component: FullScreenLayout,
        meta: {
            title: '登录'
        },
        children: [
            {
                path: '',
                name: 'loginV2New',
                meta: {
                    title: '登录',
                    allowNotLogin: true
                },
                component: LoginV2
            }
        ]
    },
    {
        path: '',
        name: 'v2Basic',
        component: FullScreenLayout,
        meta: {
            title: '首页'
        },
        children: [
            {
                path: '/home',
                name: 'homeNoUser',
                redirect: {
                    name: 'homeV2Default'
                }
            },
            {
                path: '/user/:userid/home/:activeTab',
                name: 'homeV2',
                meta: {
                    title: '欢迎',
                    authorizedRole: 'digital_human_list'
                },
                component: SummaryPage
            },
            {
                path: '/user/:userid/home',
                name: 'homeV2Default',
                meta: {
                    title: '欢迎',
                    authorizedRole: 'digital_human_list'
                },
                component: SummaryPage
            },

            // 空白的页面，专门点进入编辑器的路由打开使用的
            {
                path: '/user/:userid/ai/videoEditor',
                name: 'VideoTemplateV2',
                meta: {
                    title: '专业编辑器',
                    authorizedRole: 'digital_human_list',
                    show: false
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'TextCreate', loader: () => import('../model/TextCreate')}
                ]),
                component: importEnv('V2/Video/editor/index')
            }
        ]
    },
    {
        path: '/user/:userid',
        name: 'v2Basic',
        component: BasicLayoutV2,
        children: [
            // 为了方便区分入口来源，给外部使用的链接里，单独配置一些不同的链接
            // 在擎舵里对这种链接的路由进行重定向，转为希望使用的页面；
            // 这样后面使用中如果想修改外部链接跳转的目标页，不需要升级SDK了，直接修改这里redirect的地址即可；外部链接不需要升级替换

            // 1，图片库SDK弹窗标题跳过来的页面，转到一键出图
            {
                path: 'outerLink/imagePickerTitle',
                name: 'outerLinkImagePickerSdk',
                redirect: {
                    name: 'marketImageCreateV2'
                }
            },
            // 2，视频库SDK弹窗里跳过来的页面，转到一键成片
            {
                path: 'outerLink/videoPickerTitle',
                name: 'outerLinkVideoPickerSdk',
                redirect: {
                    name: 'MashupCreateV2'
                }
            },
            // 3，业务端AI视频工具跳过来的页面，转到一键成片
            {
                path: 'outerLink/aiVideoTool',
                name: 'outerLinkAiVideoTool',
                redirect: {
                    name: 'MashupCreateV2'
                }
            },
            // 4，图片SDK弹窗里扩图ICON跳过来的页面，转到智能扩图
            {
                path: 'outerLink/imageExpand',
                name: 'outerLinkImageExpandSdk',
                redirect: {
                    name: 'aiExpandImageV2'
                }
            },
            // 5，视频库-视频工具按钮点击跳过来的页面，转到一键成片，后期可改成模板视频
            {
                path: 'outerLink/videoPickerTool',
                name: 'outerLinkVideoPickerTool',
                redirect: {
                    name: 'MashupCreateV2'
                }
            },
            // 6，业务端投放页面顶部导航的视频工具跳转链接，当前跳到一键成片
            {
                path: 'outerLink/videoTopTool',
                name: 'outerLinkVideoTopTool',
                redirect: {
                    name: 'MashupCreateV2'
                }
            },
            // 7，业务端投放页面顶部导航的图片工具跳转链接，当前跳到一键出图
            {
                path: 'outerLink/imageTopTool',
                name: 'outerLinkImageTopTool',
                redirect: {
                    name: 'marketImageCreateV2'
                }
            },
            // 8，业务端投放页面顶部导航的标题工具跳转链接，当前跳到一键生文
            {
                path: 'outerLink/titleTopTool',
                name: 'outerLinkTitleTopTool',
                redirect: {
                    name: 'textCreateTitleV2'
                }
            },
            // 9，业务端投放页面顶部导航的互动工具跳转链接，当前跳到迁移后的新页面
            {
                path: 'outerLink/hudongTopTool',
                name: 'outerLinkHudongTopTool',
                redirect: {
                    name: 'hudongToolV2'
                }
            },
            // 10，业务端选择视频的卡位，【制作视频】按钮，转到一键成片，后续可改为模板视频
            {
                path: 'outerLink/videoCardTool',
                name: 'outerLinkVideoCardTool',
                redirect: {
                    name: 'MashupCreateV2'
                }
            },
            // 11，业务端投放页面顶部导航的互动工具跳转链接，当前跳到迁移后的新页面
            {
                path: 'outerLink/hudongCardTool',
                name: 'outerLinkHudongCardTool',
                redirect: {
                    name: 'hudongToolV2'
                }
            },
            // 12，业务端投放页面【视频预检工具】跳转链接，当前跳到迁移后的新页面
            {
                path: 'outerLink/videoPreCheckTool',
                name: 'outerLinkVideoPreCheckTool',
                redirect: {
                    name: 'videoPreCheck'
                }
            },
            // 13，业务端投放页面【灵感】跳转链接，当前跳到迁移后的新页面
            {
                path: 'outerLink/optimizationTool',
                name: 'outerLinkOptimizationTool',
                redirect: {
                    name: 'findV2Script'
                }
            },
            // 14，视频库-AI生成按钮点击跳过来的页面，转到片段生成
            {
                path: 'outerLink/videoPickerAICreate',
                name: 'outerLinkVideoPickerAICreate',
                redirect: {
                    name: 'SceneryImg2VideoV2'
                }
            },
            {
                path: 'imageCreate/marketingV2',
                name: 'marketImageCreateV2',
                meta: {
                    title: '一键出图',
                    theme: 'image',
                    authorizedRole: ['digital_human_list'],
                    anyMatch: {
                        allowInnerUser: true,
                        authorizedRole: ['digital_education_image']
                    },
                    source: 'poster'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
                    {name: 'specialCreate', loader: () => import('../model/specialCreate')},
                    {name: 'myCreation', loader: () => import('../model/myCreation')}
                ]),
                component: importEnv('V2/image/market/index')
            },
            {
                path: 'imageCreate/templateV2',
                name: 'templateV2',
                meta: {
                    title: '模板制图',
                    theme: 'image',
                    authorizedRole: ['digital_human_list'],
                    source: 'poster'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'TextCreate', loader: () => import('../model/TextCreate')},
                    {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
                    {name: 'specialCreate', loader: () => import('../model/specialCreate')},
                    {name: 'myCreation', loader: () => import('../model/myCreation')}
                ]),
                component: importEnv('V2/image/template/index')
            },
            {
                path: 'imageCreate/coverPicture',
                name: 'coverPicture',
                redirect: {
                    name: 'coverPictureV2'
                }
            },
            {
                path: 'imageCreate/coverPictureV2',
                name: 'coverPictureV2',
                meta: {
                    title: 'IP封面生成',
                    theme: 'image',
                    authorizedRole: ['digital_human_list'],
                    source: 'poster'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
                    {name: 'specialCreate', loader: () => import('../model/specialCreate')},
                    {name: 'myCreation', loader: () => import('../model/myCreation')}
                ]),
                component: importEnv('V2/image/coverPicture/index')
            },
            {
                path: 'imageCreate/batchPictureV2',
                name: 'batchPictureV2',
                meta: {
                    title: '批量生图',
                    theme: 'image',
                    authorizedRole: ['digital_human_list'],
                    source: 'poster'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
                    {name: 'specialCreate', loader: () => import('../model/specialCreate')},
                    {name: 'myCreation', loader: () => import('../model/myCreation')}
                ]),
                component: importEnv('V2/image/batchPicture/index')
            },
            {
                path: 'imageCreate/aicutoutimgV2',
                name: 'aiCutoutImageV2',
                meta: {
                    title: '智能抠图',
                    theme: 'image',
                    authorizedRole: ['digital_human_list'],
                    source: 'poster'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
                    {name: 'myCreation', loader: () => import('../model/myCreation')}
                ]),
                component: importEnv('V2/image/cutout/index')
            },
            {
                path: 'imageCreate/aiexpandimgV2',
                name: 'aiExpandImageV2',
                meta: {
                    title: '智能扩图',
                    theme: 'image',
                    authorizedRole: ['digital_human_list'],
                    source: 'poster'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
                    {name: 'specialCreate', loader: () => import('../model/specialCreate')}
                ]),
                component: importEnv('V2/image/expand/index')
            },
            {
                path: 'imageCreate/cropV2',
                name: 'cropImageCreateV2',
                meta: {
                    title: '批量裁剪',
                    theme: 'image',
                    authorizedRole: ['digital_human_list'],
                    source: 'poster'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
                    {name: 'specialCreate', loader: () => import('../model/specialCreate')}
                ]),
                component: importEnv('V2/image/crop/index')
            },
            {
                path: 'imageCreate/stitchingV2',
                name: 'stitchingImageCreateV2',
                meta: {
                    title: '多图拼接',
                    theme: 'image',
                    authorizedRole: ['digital_human_list'],
                    source: 'poster'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
                    {name: 'specialCreate', loader: () => import('../model/specialCreate')}
                ]),
                component: importEnv('V2/image/stitching/index')
            },
            // {
            //     path: 'imageCreate/imageEditor',
            //     name: 'imageEditorV2',
            //     meta: {
            //         title: '图片编辑器',
            //         theme: 'image',
            //         authorizedRole: ['digital_human_list'],
            //         source: 'poster'
            //     },
            //     beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
            //         {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
            //         {name: 'specialCreate', loader: () => import('../model/specialCreate')}
            //     ]),
            //     component: importEnv('V2/image/editor/index')
            // },
            {
                path: 'imageCreate/newImageEditor',
                name: 'newImageEditorV2',
                meta: {
                    title: '图片编辑器',
                    theme: 'image',
                    authorizedRole: ['digital_human_list'],
                    source: 'poster'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
                    {name: 'specialCreate', loader: () => import('../model/specialCreate')}
                ]),
                component: importEnv('V2/image/editor/newEditor')
            },
            // 保持原测试链接可用
            {
                path: 'v2/mashup_create',
                redirect: {
                    name: 'MashupCreateV2'
                }
            },
            // 重做新路由
            {
                path: 'videoCreate/mixedV2',
                name: 'MashupCreateV2',
                meta: {
                    title: '一键成片',
                    authorizedRole: 'digital_human_list',
                    theme: 'video',
                    show: false
                },
                component: () => import('@/component/AIDigitalHuman/index')
            },
            {
                path: 'videoCreate/ImageMixed',
                name: 'ImageMashupCreate',
                redirect: {
                    name: 'ImageMashupCreateV2'
                }
            },
            {
                path: 'videoCreate/ImageMixedV2',
                name: 'ImageMashupCreateV2',
                meta: {
                    title: '图片数字人',
                    authorizedRole: 'digital_human_list',
                    theme: 'digitalhuman',
                    show: false
                },
                component: () => import('@/component/AIDigitalHuman/index')
            },
            {
                path: 'videoCreate/highlight',
                name: 'HighlightCreate',
                meta: {
                    title: '短剧高光',
                    authorizedRole: 'digital_human_list',
                    theme: 'digitalhuman',
                    show: false
                },
                component: () => import('@/component/AIDigitalHuman/index')
            },

            {
                path: 'scriptV2',
                name: 'textCreateScriptV2All',
                meta: {
                    title: '脚本生成',
                    source: 'script',
                    backTo: 'homeV2Default',
                    theme: 'video',
                    authorizedRole: 'digital_human_list'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'TextCreate', loader: () => import('../model/TextCreate')},
                    {name: 'VideoCreate', loader: () => import('../model/VideoCreate')}
                ]),
                component: importEnv('TextCreateV2/create/AiScriptContent')
            },
            {
                path: 'scriptV2/script',
                name: 'textCreateScriptV2',
                meta: {
                    title: '脚本生成',
                    source: 'script',
                    backTo: 'homeV2Default',
                    theme: 'video',
                    authorizedRole: 'digital_human_list'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'TextCreate', loader: () => import('../model/TextCreate')},
                    {name: 'VideoCreate', loader: () => import('../model/VideoCreate')}
                ]),
                component: importEnv('TextCreateV2/create/AiScriptContent')
            },
            {
                path: 'scriptV2/shortplay',
                name: 'textCreateShortplayV2',
                meta: {
                    title: '情景剧本生成',
                    source: 'shortplay',
                    backTo: 'homeV2Default',
                    theme: 'video'
                    // authorizedRole: 'qingduo_short_play'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'TextCreate', loader: () => import('../model/TextCreate')},
                    {name: 'VideoCreate', loader: () => import('../model/VideoCreate')}
                ]),
                component: importEnv('TextCreateV2/create/AiScriptContent')
            },
            {
                path: 'textCreate/titleV2',
                name: 'textCreateTitleV2',
                meta: {
                    title: '一键生文',
                    source: 'feed',
                    authorizedRole: 'digital_human_list',
                    theme: 'text'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('TextCreate', () =>
                    import('../model/TextCreate')
                ),
                component: importEnv('TextCreateV2/create/AiContent')
            },
            {
                path: 'videoCreate/humanCreateV2',
                name: 'HumanCreateV2',
                meta: {
                    title: '形象定制',
                    authorizedRole: 'digital_human_list',
                    sdkName: 'HumanCreateV2',
                    show: false,
                    theme: 'digitalhuman'
                },
                component: () => import('@/views/V2/Market/VideoTemplate')
            },
            {
                path: 'videoCreate/voiceCreateV2',
                name: 'VoiceCreateV2',
                meta: {
                    title: '语音复刻',
                    authorizedRole: 'digital_human_list',
                    sdkName: 'VoiceCreateV2',
                    show: false,
                    theme: 'digitalhuman'
                },
                component: () => import('@/views/V2/Market/VideoTemplate')
            },
            {
                path: 'img2Video/scenery',
                name: 'SceneryImg2VideoV2',
                meta: {
                    title: '片段生成',
                    authorizedRole: 'is_qingduo_uc_user',
                    show: false,
                    theme: 'video'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'Image2Video', loader: () => import('../model/Image2Video')},
                    {name: 'ImageCreate', loader: () => import('../model/ImageCreate')}
                ]),
                component: () => import('@/views/V2/Img2Video/Index')
            },
            {
                path: 'hudongTool',
                name: 'hudongToolV2',
                meta: {
                    title: '互动工具',
                    authorizedRole: 'is_qingduo_uc_user',
                    sdkName: 'CSHudongToolV2',
                    show: false
                },
                component: () => import('@/views/V2/Market/VideoTemplate')
            },
            {
                path: 'videoTplCreate',
                name: 'videoTplCreate',
                meta: {
                    title: '模板视频',
                    // authorizedRole: 'qingduo_image_digital',
                    show: false,
                    theme: 'video'
                },
                component: () => import('@/views/V2/VideoTpl/Index'),
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('videoComposition', () =>
                    import('../model/videoComposition')
                )
            },
            {
                path: 'workflow',
                name: 'videoWorkflowV2',
                meta: {
                    title: 'AI创编大师',
                    authorizedRole: 'qingduo_ai_video_workflow',
                    sdkName: 'VideoWorkFlow',
                    show: false
                },
                component: () => import('@/views/V2/Market/VideoTemplate'),
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'VideoCreate', loader: () => import('../model/VideoCreate')}
                ])
            }
        ]
    },
    {
        path: '/user/:userid/diagnoseV2',
        name: 'analysisV2',
        component: BasicLayoutV2,
        children: [
            {
                path: '',
                name: 'analysisV2',
                component: () => import('@/layouts/ContentLayout'),
                props: {
                    leftNavConfig: diagnoseConfig
                },
                children: [
                    {
                        path: 'afterput',
                        name: 'diagnoseAfterPut',
                        meta: {
                            authorizedRole: 'digital_human_list',
                            title: '投后诊断',
                            forbidOuterUser: true
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                            {name: 'DiagnoseModel', loader: () => import('../model/Diagnose')}
                        ]),
                        component: () => import('@/views/V2/Diagnose/afterput/index')
                    },
                    {
                        path: 'preCheck',
                        name: 'videoPreCheck',
                        meta: {
                            authorizedRole: 'is_qingduo_uc_user',
                            title: '视频预检',
                            titleTip: '预检结果为机器检测，请以投放实际审核结果为准'
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                            {name: 'DiagnoseModel', loader: () => import('../model/Diagnose')}
                        ]),
                        component: () => import('@/views/V2/Diagnose/videoPreCheck/index')
                    }
                ]
            }
        ]
    }
];
